<template>
  <div class="ba-card ba6-security ba-w-100 ba-flex ba-gp-1 ba-f-column">
        <div class="ba-top">
          <span class="ba-title">{{ t.security }}</span>
          <div v-if="tabs[1].status && tokenPage == 1" class="ba-box-items ba-flex ba-gp-1" @click="activate2FaToken('getCode')">
            <button 
              v-if="type2FA === 'create'" 
              :class="['ba-btn', 'ba-sm', 'ba-blue']" 
              v-text="t.dns_activate">
            </button>
            <button 
              v-else-if="type2FA === 'disable'" 
              :class="['ba-btn', 'ba-sm', 'ba-red']" 
              v-text="t.label_desativar">
            </button>
          </div>
          <div v-else-if="tabs[1].status && tokenPage == 2" class="ba-box-items ba-flex ba-gp-1" @click="activate2FaToken('sendCode')">
            <button :class="['ba-btn', 'ba-sm', 'ba-blue', !validateFieldsCode2Fa ? 'ba-disabled' : '']" :disabled="!validateFieldsCode2Fa">{{ t.Twofa_send_code }}</button>
          </div>
          <div v-else-if="tabs[1].status && tokenPage == 3" class="ba-box-items ba-flex ba-gp-1" @click="resetData()">
            <button class="ba-btn ba-sm ba-blue">{{ t.back }}</button>
          </div>
          <div v-else-if="tabs[3].status" class="ba-box-items ba-flex ba-gp-1">
            <button class="ba6-btn-i-do-not-agree" @click="toggleModal('ba6-modal-i-do-not-agree')">{{ t.i_desagree }}</button>
          </div>
        </div>
        <div class='ba-content ba-w-100 ba-flex ba-gp-1 ba-f-column'>
          <div class='ba-box-tabs'>
              <a v-for="t,i in tabs" :key="i" :class="['ba-tab', t.status ? 'ba-is-active' : '', i == 4 ? 'ba6-red-element' : '']" @click="defineTabStatus(i)" v-text="t.title"></a>
          </div>
          <!-- Password -->
          <div v-if="tabs[0].status" class="ba-flex ba-gp-08 ba-f-column">
            <div class='ba-box-input ba-md'>
                <div class='ba-info'>
                    <div class='ba-info-left'>
                        <label class='ba-label' for='current-password'>{{ t.dns_current_password }}</label>
                    </div>
                </div>
                <input type='password' id='current-password' v-model="form.current_password" class="ba-input ba-disabled" disabled />
            </div>
            <button class="link-element" @click="toggleModal('ba6-modal-change-password')">{{ t.forgot_change_password + ' ?' }}</button>
            <ba6-modal modal-id="ba6-modal-change-password">
                <div class='ba-card ba-jc-sb ba-w-100 ba-no-shadow'>
                    <div class='ba-top'>
                        <span class='ba-title'>{{ t.dns_change_password }}</span>
                        <div class='ba-box-items ba-flex ba-gp-1'>
                            <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-modal-change-password')">
                                <builderall-icon code='64f7' />
                            </button>
                        </div>
                    </div>
                    <div class="ba-content-main">
                      <p class="ba6-change-password-p">{{ t.change_password_message }} {{ accountInfo.user_data.email_sanitized }} {{ t.change_password_confirm }}</p>
                    </div>
                    <div class="ba-content-footer ba-w-100 ba-flex ba-jc-fe">
                      <button :class="['ba-btn', 'ba-md', 'ba-blue', loadingChangePassword ? 'ba-disabled' : '']" :disabled="loadingChangePassword" @click="changePasswordRequest()">
                          {{ t.change_password_submit }}
                      </button>
                    </div>
                </div>
            </ba6-modal>
          </div>
          <!-- 2FA Token -->
          <div v-if="tabs[1].status">
            <builderall-loader :loading="loading2FA">
              <div v-if="tokenPage == 1" class="ba-flex ba-f-column ba-text-center ba-gp-1">
                <p class="ba6-p-element" v-html="t.two_factor_auth_first_page_title"></p>
                <p class="ba6-p-element" v-if="type2FA === 'create'" v-html="t.two_factor_auth_first_page_desc_active"></p>
                <p class="ba6-p-element" v-else-if="type2FA === 'disable'" v-html="t.two_factor_auth_first_page_desc_inactive"></p>
                <div class="ba-w-100 ba-flex ba-jc-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="207" height="207" viewBox="0 0 207 207" fill="none">
                    <path d="M168.188 138L103.5 176.812L38.8125 138V30.1875H168.188V138Z" fill="#768BA0"/>
                    <path d="M189.75 30.1875V150.938L103.5 202.688L17.25 150.938V30.1875H38.8125V138L103.5 176.812L168.188 138V30.1875H172.5H189.75Z" fill="#A4B0C0"/>
                    <path d="M189.75 12.9375V30.1875H17.25V12.9375C17.2568 10.6521 18.1677 8.46227 19.7837 6.84624C21.3998 5.23022 23.5896 4.31933 25.875 4.3125H181.125C183.41 4.31933 185.6 5.23022 187.216 6.84624C188.832 8.46227 189.743 10.6521 189.75 12.9375Z" fill="#D0D7DF"/>
                    <path d="M125.062 77.625H81.9375C77.174 77.625 73.3125 81.4865 73.3125 86.25V120.75C73.3125 125.513 77.174 129.375 81.9375 129.375H125.062C129.826 129.375 133.688 125.513 133.688 120.75V86.25C133.688 81.4865 129.826 77.625 125.062 77.625Z" fill="#FED049"/>
                    <path d="M112.125 90.5625H94.875C93.7313 90.5625 92.6343 91.0168 91.8256 91.8256C91.0168 92.6343 90.5625 93.7313 90.5625 94.875C90.5625 96.0187 91.0168 97.1157 91.8256 97.9244C92.6343 98.7332 93.7313 99.1875 94.875 99.1875H99.1875V112.125C99.1875 113.269 99.6418 114.366 100.451 115.174C101.259 115.983 102.356 116.438 103.5 116.438C104.644 116.438 105.741 115.983 106.549 115.174C107.358 114.366 107.812 113.269 107.812 112.125V99.1875H112.125C113.269 99.1875 114.366 98.7332 115.174 97.9244C115.983 97.1157 116.438 96.0187 116.438 94.875C116.438 93.7313 115.983 92.6343 115.174 91.8256C114.366 91.0168 113.269 90.5625 112.125 90.5625Z" fill="#F6B445"/>
                    <path d="M90.562 64.7393C90.4992 64.1552 90.5672 63.5646 90.7609 63.0101C90.9546 62.4556 91.2694 61.9512 91.6822 61.5334C92.0951 61.1155 92.5957 60.7948 93.1478 60.5945C93.7 60.3941 94.2898 60.3192 94.8745 60.375H112.073C112.657 60.313 113.247 60.3815 113.801 60.5755C114.355 60.7696 114.859 61.0843 115.277 61.497C115.695 61.9096 116.015 62.41 116.216 62.9617C116.417 63.5135 116.492 64.103 116.437 64.6875V77.625H125.062V64.6875C125.112 62.9749 124.812 61.2702 124.179 59.6779C123.547 58.0856 122.596 56.6393 121.384 55.4278C120.173 54.2163 118.726 53.2652 117.134 52.6328C115.542 52.0003 113.837 51.6999 112.125 51.75H94.8745C93.1619 51.6999 91.4572 52.0003 89.8649 52.6328C88.2726 53.2652 86.8263 54.2163 85.6148 55.4278C84.4034 56.6393 83.4522 58.0856 82.8198 59.6779C82.1873 61.2702 81.8869 62.9749 81.937 64.6875V77.625H90.562V64.7393Z" fill="#A4B0C0"/>
                    <path d="M189.75 21.5625H17.25V30.1875H189.75V21.5625Z" fill="#C1C8CF"/>
                    <path d="M168.188 30.1875H38.8125V38.8125H168.188V30.1875Z" fill="#697C8F"/>
                  </svg>
                </div>
              </div>
              <div v-else-if="tokenPage == 2" class="ba-flex ba-f-column ba-text-center ba-gp-1">
                <div>
                  <p class="ba6-p-element" v-if="type2FA === 'create'" v-html="t.two_factor_auth_second_page_title_active"></p>
                  <p class="ba6-p-element" v-else-if="type2FA === 'disable'" v-html="t.two_factor_auth_second_page_title_inactive"></p>
                </div>
                <div class="ba-w-100 ba-flex ba-f-column ba-ai-center qr-code-group" v-if="type2FA === 'create'">
                  <img v-if="url2FA" :src="url2FA">
                  <div v-else class="fake-url-2fa-img"></div>
                </div>
                <div class="ba-w-100 ba-flex ba-jc-center" v-else-if="type2FA === 'disable'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="207" height="207" viewBox="0 0 207 207" fill="none">
                    <path d="M168.188 138L103.5 176.812L38.8125 138V30.1875H168.188V138Z" fill="#768BA0"/>
                    <path d="M189.75 30.1875V150.938L103.5 202.688L17.25 150.938V30.1875H38.8125V138L103.5 176.812L168.188 138V30.1875H172.5H189.75Z" fill="#A4B0C0"/>
                    <path d="M189.75 12.9375V30.1875H17.25V12.9375C17.2568 10.6521 18.1677 8.46227 19.7837 6.84624C21.3998 5.23022 23.5896 4.31933 25.875 4.3125H181.125C183.41 4.31933 185.6 5.23022 187.216 6.84624C188.832 8.46227 189.743 10.6521 189.75 12.9375Z" fill="#D0D7DF"/>
                    <path d="M125.062 77.625H81.9375C77.174 77.625 73.3125 81.4865 73.3125 86.25V120.75C73.3125 125.513 77.174 129.375 81.9375 129.375H125.062C129.826 129.375 133.688 125.513 133.688 120.75V86.25C133.688 81.4865 129.826 77.625 125.062 77.625Z" fill="#FED049"/>
                    <path d="M112.125 90.5625H94.875C93.7313 90.5625 92.6343 91.0168 91.8256 91.8256C91.0168 92.6343 90.5625 93.7313 90.5625 94.875C90.5625 96.0187 91.0168 97.1157 91.8256 97.9244C92.6343 98.7332 93.7313 99.1875 94.875 99.1875H99.1875V112.125C99.1875 113.269 99.6418 114.366 100.451 115.174C101.259 115.983 102.356 116.438 103.5 116.438C104.644 116.438 105.741 115.983 106.549 115.174C107.358 114.366 107.812 113.269 107.812 112.125V99.1875H112.125C113.269 99.1875 114.366 98.7332 115.174 97.9244C115.983 97.1157 116.438 96.0187 116.438 94.875C116.438 93.7313 115.983 92.6343 115.174 91.8256C114.366 91.0168 113.269 90.5625 112.125 90.5625Z" fill="#F6B445"/>
                    <path d="M90.562 64.7393C90.4992 64.1552 90.5672 63.5646 90.7609 63.0101C90.9546 62.4556 91.2694 61.9512 91.6822 61.5334C92.0951 61.1155 92.5957 60.7948 93.1478 60.5945C93.7 60.3941 94.2898 60.3192 94.8745 60.375H112.073C112.657 60.313 113.247 60.3815 113.801 60.5755C114.355 60.7696 114.859 61.0843 115.277 61.497C115.695 61.9096 116.015 62.41 116.216 62.9617C116.417 63.5135 116.492 64.103 116.437 64.6875V77.625H125.062V64.6875C125.112 62.9749 124.812 61.2702 124.179 59.6779C123.547 58.0856 122.596 56.6393 121.384 55.4278C120.173 54.2163 118.726 53.2652 117.134 52.6328C115.542 52.0003 113.837 51.6999 112.125 51.75H94.8745C93.1619 51.6999 91.4572 52.0003 89.8649 52.6328C88.2726 53.2652 86.8263 54.2163 85.6148 55.4278C84.4034 56.6393 83.4522 58.0856 82.8198 59.6779C82.1873 61.2702 81.8869 62.9749 81.937 64.6875V77.625H90.562V64.7393Z" fill="#A4B0C0"/>
                    <path d="M189.75 21.5625H17.25V30.1875H189.75V21.5625Z" fill="#C1C8CF"/>
                    <path d="M168.188 30.1875H38.8125V38.8125H168.188V30.1875Z" fill="#697C8F"/>
                  </svg>
                </div>
                <div class="ba-w-100 ba-flex ba-f-column ba-ai-center margin-top" v-if="url2FA">
                  <ba6-code-inputs :getCodeInput="checkCode" :t="t" :setCode="defineCode" :qtyInputs="6" />
                </div>
              </div>
              <div v-else class="ba-flex ba-f-column ba-ai-center ba-text-center ba-gp-1">
                <div class="ba-w-100 ba-flex ba-jc-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="207" height="207" viewBox="0 0 207 207" fill="none">
                    <path d="M168.188 138L103.5 176.812L38.8125 138V30.1875H168.188V138Z" fill="#768BA0"/>
                    <path d="M189.75 30.1875V150.938L103.5 202.688L17.25 150.938V30.1875H38.8125V138L103.5 176.812L168.188 138V30.1875H172.5H189.75Z" fill="#A4B0C0"/>
                    <path d="M189.75 12.9375V30.1875H17.25V12.9375C17.2568 10.6521 18.1677 8.46227 19.7837 6.84624C21.3998 5.23022 23.5896 4.31933 25.875 4.3125H181.125C183.41 4.31933 185.6 5.23022 187.216 6.84624C188.832 8.46227 189.743 10.6521 189.75 12.9375Z" fill="#D0D7DF"/>
                    <path d="M125.062 77.625H81.9375C77.174 77.625 73.3125 81.4865 73.3125 86.25V120.75C73.3125 125.513 77.174 129.375 81.9375 129.375H125.062C129.826 129.375 133.688 125.513 133.688 120.75V86.25C133.688 81.4865 129.826 77.625 125.062 77.625Z" fill="#FED049"/>
                    <path d="M112.125 90.5625H94.875C93.7313 90.5625 92.6343 91.0168 91.8256 91.8256C91.0168 92.6343 90.5625 93.7313 90.5625 94.875C90.5625 96.0187 91.0168 97.1157 91.8256 97.9244C92.6343 98.7332 93.7313 99.1875 94.875 99.1875H99.1875V112.125C99.1875 113.269 99.6418 114.366 100.451 115.174C101.259 115.983 102.356 116.438 103.5 116.438C104.644 116.438 105.741 115.983 106.549 115.174C107.358 114.366 107.812 113.269 107.812 112.125V99.1875H112.125C113.269 99.1875 114.366 98.7332 115.174 97.9244C115.983 97.1157 116.438 96.0187 116.438 94.875C116.438 93.7313 115.983 92.6343 115.174 91.8256C114.366 91.0168 113.269 90.5625 112.125 90.5625Z" fill="#F6B445"/>
                    <path d="M90.562 64.7393C90.4992 64.1552 90.5672 63.5646 90.7609 63.0101C90.9546 62.4556 91.2694 61.9512 91.6822 61.5334C92.0951 61.1155 92.5957 60.7948 93.1478 60.5945C93.7 60.3941 94.2898 60.3192 94.8745 60.375H112.073C112.657 60.313 113.247 60.3815 113.801 60.5755C114.355 60.7696 114.859 61.0843 115.277 61.497C115.695 61.9096 116.015 62.41 116.216 62.9617C116.417 63.5135 116.492 64.103 116.437 64.6875V77.625H125.062V64.6875C125.112 62.9749 124.812 61.2702 124.179 59.6779C123.547 58.0856 122.596 56.6393 121.384 55.4278C120.173 54.2163 118.726 53.2652 117.134 52.6328C115.542 52.0003 113.837 51.6999 112.125 51.75H94.8745C93.1619 51.6999 91.4572 52.0003 89.8649 52.6328C88.2726 53.2652 86.8263 54.2163 85.6148 55.4278C84.4034 56.6393 83.4522 58.0856 82.8198 59.6779C82.1873 61.2702 81.8869 62.9749 81.937 64.6875V77.625H90.562V64.7393Z" fill="#A4B0C0"/>
                    <path d="M189.75 21.5625H17.25V30.1875H189.75V21.5625Z" fill="#C1C8CF"/>
                    <path d="M168.188 30.1875H38.8125V38.8125H168.188V30.1875Z" fill="#697C8F"/>
                  </svg>
                </div>
                <p v-if="type2FA === 'create'" class="ba6-p-element" v-html="t.two_factor_auth_third_page_desc_active"></p>
                <p v-if="type2FA === 'disable'" class="ba6-p-element" v-html="t.two_factor_auth_third_page_desc_inactive"></p>
              </div>
            </builderall-loader>
          </div>
          <!-- User Log -->
          <builderall-loader :loading="loadingUserLogs" v-if="tabs[2].status">
            <table class='ba6-log-table ba-w-100 ba-table ba-md ba-lines'>
              <thead>
                  <tr>
                      <th style="width: 15%;">{{ t.ip_adress }}</th>
                      <th style="width: 15%;">{{ t.label_date }}</th>
                      <th style="width: 10%;" v-if="userLogs.is_admin || userLogs.is_franquia">{{ t.label_autor }}</th>
                      <th style="width: 15%;">{{ t.dns_type }}</th>
                      <th style="width: 20%;">{{ t.consent_description_title }}</th>
                      <th style="width: 15%;">{{ t.browser }}</th>
                      <th style="width: 10%;"></th>
                  </tr>
              </thead>
              <tbody v-if="!userLogs.logs == false">
                  <tr v-for="l,i in userLogs.logs" :key="i">
                      <td class="ba-montserrat-bold">
                        <b v-text="l.ip"></b><br>
                        <div v-if="l.location">
                          <b v-text="t.label_country+': ' + l.location.countryName"></b><br>
                          <b v-text="t.country_code+': ' + l.location.countryCode"></b><br>
                          <b v-text="t.dns_region+': ' + l.location.regionName"></b><br>
                          <b v-text="t.city+': ' + l.location.cityName"></b>
                        </div>
                      </td>
                      <td v-text="l.date"></td>
                      <td v-if="userLogs.is_admin || userLogs.is_franquia">
                        <span v-if="l.id_admin" v-text="'Admin ' + l.nome_admin"></span>
                        <span v-else-if="l.id_franquia" v-text="'Franchise ' + (userLogs.is_admin ? l.nome_admin : '')"></span>
                        <span v-else v-text="'User'"></span>
                      </td>
                      <td v-text="separeteKey(l.key)"></td>
                      <td v-text="l.description"></td>
                      <td v-text="!l.browser ? '-' : l.browser"></td>
                      <td>
                        <div class="ba-flex ba-gp-1 ba-ai-center ba-jc-center">
                          <button
                            class="ba-btn ba-btn-normal ba-sm ba-rounded"
                            ba-tooltip-position="top"
                            :ba-tooltip-title="l.user_agent"
                          >
                            <builderall-icon code='eye'></builderall-icon>
                          </button>
                          <a href="https://explore.whatismybrowser.com/useragents/parse/" target="_blank" class='ba-btn ba-btn-normal ba-sm ba-rounded'>
                            <builderall-icon code='1c86'></builderall-icon>
                          </a>
                        </div>
                      </td>
                  </tr>
              </tbody>
              <tbody v-else-if="!loadingUserLogs">
                  <tr>
                    <td class='ba-no-records-found'>{{ t.no_record_found }}</td>
                  </tr>
              </tbody>
              <tbody v-else>
                  <tr>
                    <td class='ba-no-records-found'>{{ t.dns_loading }}</td>
                  </tr>
              </tbody>
            </table>
            <nav v-if="userLogs.page_count > 1" class='ba-mg-1 ba-pagination ba-md'>
                <ul class='ba-jc-center ba-list'>
                    <li v-if="currentPageUserLogs > 1" class='ba-nav-item'>
                        <a class='ba-back' @click="defineCurrentPageUserLogs('back')">
                            <span class='ba-icon'>
                                <builderall-icon code='arrow-left' />
                            </span>
                        </a>
                    </li>
<!--                    <li v-for="p,i in userLogs.page_count" :key="i" class='ba-nav-item'>-->
<!--                        <a :class="['ba-link', currentPageUserLogs == (i+1) ? 'ba-is-active' : '']" @click="defineCurrentPageUserLogs(i+1)" v-text="i+1"></a>-->
<!--                    </li>-->
                  <li v-for="(a, i) in pagesToShow" :key="i"
                      class='ba-nav-item'
                  >
                    <a :class="['ba-link', currentPageUserLogs == a ? 'ba-is-active': '']"
                       @click="defineCurrentPageUserLogs(a)"
                    >{{ a }}
                    </a>
                  </li>
                    <li v-if="currentPageUserLogs < userLogs.page_count" class='ba-nav-item'>
                        <a class='ba-next' @click="defineCurrentPageUserLogs('next')">
                            <span class='ba-icon'>
                                <builderall-icon code='arrow-right' />
                            </span>
                        </a>
                    </li>
                </ul>
            </nav>
          </builderall-loader>
          <!-- Terms of use and privacy policy -->
          <div v-if="tabs[3].status" class="ba6-terms ba-flex ba-f-column ba-ai-center ba-gp-2 ba-mg-t-2">
            <a :href="securityData.terms_of_use" target="_blank" class="ba6-btn-terms ba-btn ba-blue ba-md">{{ t.label_terms_of_use }}</a>
            <a :href="securityData.privacy_policy" target="_blank" class="ba6-btn-terms ba-btn ba-blue ba-md">{{ t.ush_privacy_policy }}</a>
            <span v-if="termsAccepted">
              <strong class="ba-text-uppercase" v-text="t.terms_accept_in + ' ' + termsAccepted"></strong>
            </span>
            <p class="ba6-p-element">{{ replaceDateAccept(t.term_or_privacy_accepted) }}</p>
            <ba6-modal modal-id="ba6-modal-i-do-not-agree">
              <div class='ba6-modal-i-do-not-agree-content ba-toast ba-jc-sb ba-error'>
                <div class='ba-toast-alert'>
                  <div class='ba-left'>
                    <span class='ba-icon'></span>
                    <span class='ba-text' v-text="t.dns_important"></span>
                  </div>
                </div>
                <span class='ba-description ba-text-left'>
                  {{ t.label_delete_redir }}
                  <br>
                  {{ t.label_delet_redir_confirm }}
                </span>
                <div class="ba-flex ba-jc-sb ba-gp-1">
                  <button class='ba-btn ba-white ba-lg' @click="toggleModal('ba6-modal-i-do-not-agree')">{{ t.button_cancelar }}</button>
                  <a :href="this.routes.rota_office_autodelete+'/'+this.accountInfo.user_data.id" class="ba-btn ba-md ba-red">
                    {{ t.change_password_submit }}
                  </a>
                </div>
              </div>
            </ba6-modal>
          </div>
          <!-- Delete account -->
          <div v-if="tabs[4].status" class="ba6-delete-account ba-flex ba-f-column ba-ai-center ba-gp-2 ba-mg-t-2">
            <div class="ba-flex ba-ai-center ba-gp-06">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
                <path d="M0.833984 16.4998L10.0007 0.666504L19.1673 16.4998H0.833984ZM10.0876 14.0623C10.2658 14.0623 10.4138 14.0021 10.5319 13.8816C10.65 13.7611 10.709 13.6118 10.709 13.4337C10.709 13.2556 10.6487 13.1075 10.5283 12.9894C10.4078 12.8714 10.2585 12.8123 10.0803 12.8123C9.90221 12.8123 9.75412 12.8726 9.63607 12.9931C9.51801 13.1136 9.45898 13.2629 9.45898 13.441C9.45898 13.6191 9.51923 13.7672 9.63971 13.8853C9.76021 14.0033 9.90952 14.0623 10.0876 14.0623ZM9.45898 11.7498H10.709V7.08317H9.45898V11.7498Z" fill="#EB4E2A"/>
              </svg>
              <h4 v-text="t.dns_attention"></h4>
            </div>
            <div class="ba-text-center">
              <p class="ba6-p-element">{{ t.description_delete_account }}</p>
              <p class="ba6-p-element">{{ t.security_data_deletion_request }} <a :href="this.routes.rota_office_support_system_ticket" target="_blank">{{ t.security_contact_support }}.</a></p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "ba6-security",
  props: ['accountInfo','routes','securityData','t','popup', 'openPasswordReset'],
  data() {
    return {
      tabs: [
        { title: this.t.label_password2_v5,       status: true },
        { title: this.t.label_2fa_token,          status: false },
        { title: this.t.user_log,                 status: false },
        { title: this.t.terms_use_privacy_policy, status: false },
        { title: this.t.label_account_deletion,   status: false },
      ],
      form: {
        current_password: '*********'
      },
      tokenPage: 1,
      url2FA: null,
      loading2FA: false,
      loadingChangePassword: false,
      loadingUserLogs: false,
      type2FA: 'create',
      termsAccepted: this.securityData.accepted_date,
      userLogs: {},
      currentPageUserLogs: 1,
      validateFieldsCode2Fa: false,
      code2fa: null,
    }
  },
  mounted() {
    if(this.accountInfo.user_data.office_configuracoes.token_2fa && this.accountInfo.user_data.office_configuracoes.token_2fa == 'SIM')
    {
      this.type2FA = 'disable';
    }
    if(this.popup == "password" || this.openPasswordReset){
      this.toggleModal('ba6-modal-change-password');
    }
  },
  computed: {
    pagesToShow() {
      const pages = [];
      const totalPages = this.userLogs.page_count;

      if (totalPages <= 6) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        const initPages = [1, 2, 3];
        const finalPages = [totalPages - 2, totalPages - 1, totalPages];

        pages.push(...initPages, '...', ...finalPages);
      }

      return pages;
    }
  },
  methods: {
    defineTabStatus(index){
      this.tabs.find(x => x.status).status = false;
      this.tabs[index].status = true;
      this.resetData();
      if(index == 2)
      {
        this.getUserLogData();
        this.currentPageUserLogs = 1;
      }
    },
    replaceDateAccept(data){
      return data.replace("{{data_accept}}", this.termsAccepted).replace("<br> ", "");
    },
    toggleModal(data){
      $(`#${data}`).toggle('show');
    },
    separeteKey(data){
      return data.split("_").join(" ");
    },
    changePasswordRequest(){
      this.loadingChangePassword = true;

      let params = new URLSearchParams(document.location.search);
      let showPasswordResetPopup = params.get("showPasswordResetPopup") == "true"

      const formData = new FormData();
      formData.append('email', this.accountInfo.user_data.email_sanitized);
      formData.append('force_logout_all', showPasswordResetPopup);

      axios
        .post(this.routes.rota_office_forgot_password, formData)
        .then((response)=>{
            if(response.data.success)
            {
              alertMsg("success", this.t.sent);
            }
            else
            {
              alertMsg("error", this.t.sent_error);
            }
        })
        .catch((error)=>{
          console.error(error);
        })
        .finally(()=>{
          this.loadingChangePassword = false;
        })
    },
    activate2FaToken(data){
      if(data == 'getCode')
      {
        this.handleImage();
        this.tokenPage = 2;
      }
      else if(data == 'sendCode')
      {
        if(this.validateFieldsCode2Fa)
        {
          this.checkCode();
        }
        else
        {
          alertMsg('error', this.t.complete_correctly_fields);
        }
      }
    },
    defineCode(validate, code){
      this.validateFieldsCode2Fa = validate;
      this.code2fa = code;
    },
    handleImage(){
      this.loading2FA = true;
      axios
        .get(this.routes.route_token_2fa_get)
        .then((resposta) => {
          this.url2FA = resposta.data.url;
        })
        .catch((error)=>{
          console.error(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading2FA = false;
          }, 2000);
        });
    },
    checkCode(){
      const valInput = this.code2fa;

      let url = `${this.routes.route_token_2fa_check}?token=${valInput}&isFirstTime=${valInput}`;
      if(this.type2FA == 'disable')
      {
        url = `${this.routes.route_token_2fa_check}?token=${valInput}&isToDisable=true`;
      }

      axios
        .post(url)
        .then((response) => {
          if(response.data.success)
          {
            this.tokenPage = 3;
          }
          else
          {
            alertMsg('error', this.t.Twofa_invalid_code);
          }
        });
    },
    getUserLogData(){
      this.loadingUserLogs = true;

      axios
        .get(this.routes.rota_office_log_usuario+'/'+this.currentPageUserLogs)
        .then((response) => {
          if(response.data.data)
          {
            this.userLogs = response.data.data;
            this.getBrowserToLogs(this.userLogs.logs);
          }
        })
        .catch((error)=>{
          console.error('Error to get user log: ', error);
        })
        .finally(() => {
          this.loadingUserLogs = false;
        });
    },
    getBrowserToLogs(data){
      const url = 'https://www.whatsmyua.info/api/v1/ua?ua=';

      for(let i = 0; i < data.length; i++)
      {
        fetch(url + data[i].user_agent)
          .then(response => response.json())
          .then(res => {
            this.$set(this.userLogs.logs[i], 'browser', res[2].device.description);
          })
          .catch(error => {
            console.error('Error fetching user agent:', error);
          });
      }
    },
    defineCurrentPageUserLogs(data){
      if(data == 'back')
      {
        this.currentPageUserLogs -= 1;
      }
      else if(data == 'next')
      {
        this.currentPageUserLogs += 1;
      }
      else
      {
        this.currentPageUserLogs = data;
      }
      this.getUserLogData();
    },
    resetData(){
      if (this.tokenPage == 3)
      {
        this.type2FA = this.type2FA == 'disable'
          ? 'create'
          : 'disable';
      }

      this.tokenPage = 1;
      this.url2FA = null;
      this.validateFieldsCode2Fa = false;
      this.code2fa = null;
    }
  },
}
</script>

<style scoped lang="scss">
  .link-element{
    color: #0072E1;
    font-size: 14px;
    font-weight: 500;
    text-decoration-line: underline;
    background: transparent;
    border: none;
    outline: none;
    text-align: left;
  }
  .ba6-btn-i-do-not-agree{
    border-radius: 6px;
    border: 1px solid #4D5D71;
    background: transparent;
    color: #4D5D71;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.66px;
    text-transform: uppercase;
    padding: 0.4rem 0.8rem;
  }
  .ba6-change-password-p{
    color: #111827;
    font-size: 16px;
    font-weight: 500;
  }
  .ba6-p-element{
    color: #4D5D71;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.66px;
  }
  .fake-url-2fa-img{
    width: 200px;
    height: 200px;
  }
  .ba6-terms{
    text-align: center;
    span{
      strong{
        font-size: 12px;
      }
    }
    .ba6-btn-terms{
      width: 300px;
    }
  }
  .ba6-log-table{
    tbody{
      b{
        font-size: 13px !important;
      }
      td {
        word-break: break-word;
        white-space: normal;
      }
      td,span{
        font-size: 12px !important;
      }
      td:not(:first-child), span{
        color: #8D9EB5;
        font-weight: 500;
        letter-spacing: 0.6px;
      }
    }
  }
  .ba6-modal-i-do-not-agree-content{
    height: 230px;
    .ba-description{
      font-size: 14px;
    }
  }
  .ba-is-active.ba6-red-element{
    background-color: #FCEDE9 !important;
    color: #F92A38 !important;
  }
  .ba6-red-element{
    &:hover{
      background-color: #FCEDE9 !important;
      color: #F92A38 !important;
    }
  }
  .ba6-delete-account{
    h4{
      margin: 0;
    }
  }
  .ba-nav-item:has(.ba6-dont-show){
    display: none;
  }
  .margin-top {
    margin-top: 10px;
  }
  .qr-code-group {
    min-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/routes/Security.vue